import PeriodontalPage from '@/pages/PeriodontalPage/PeriodontalPage.vue'

export default PeriodontalPage
